class CartRemovalModal {
    constructor() {
        this.modal = null;
        this.overlay = null;

        this.confirmCallback = () => { };
        this.noCallback = () => { };

        this.init();
    }

    init() {
        // Create modal HTML structure
        this.createModal();

        // Bind events
        this.bindEvents();
    }

    createModal() {
        // Create overlay
        this.overlay = document.createElement('div');
        this.overlay.className = 'removal-confirmation-overlay';
        this.overlay.innerHTML = `
      <div class="removal-confirmation-modal">
        <div class="removal-modal-header">
          <h3 class="removal-modal-title">Remove Item</h3>
          <button class="removal-modal-close" type="button">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div class="removal-modal-content">
          <div class="removal-modal-product">
            <img class="removal-modal-product-image" src="" alt="">
          </div>
          <p class="removal-modal-subtitle"></p>
          <p class="removal-modal-description"></p>
          <div class="removal-modal-actions">
            <button class="removal-modal-button removal-modal-button-cancel" type="button">Cancel</button>
            <button class="removal-modal-button removal-modal-button-confirm" type="button">Yes, Remove</button>
          </div>
        </div>
      </div>
    `;

        // Append to body
        document.body.appendChild(this.overlay);

        // Get modal element
        this.modal = this.overlay.querySelector('.removal-confirmation-modal');
    }

    bindEvents() {
        // Close button
        const closeBtn = this.overlay.querySelector('.removal-modal-close');
        closeBtn.addEventListener('click', () => this.hide());

        // Cancel button
        const cancelBtn = this.overlay.querySelector('.removal-modal-button-cancel');
        cancelBtn.addEventListener('click', () => this.hide());

        // Confirm button
        const confirmBtn = this.overlay.querySelector('.removal-modal-button-confirm');
        confirmBtn.addEventListener('click', () => this.confirmRemoval());

        // Click outside to close (only on overlay, not modal)
        this.overlay.addEventListener('click', (event) => {
            if (event.target === this.overlay) {
                this.hide();
            }
        });

        // Escape key to close
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.isVisible()) {
                this.hide();
            }
        });

        // Bind to existing remove buttons
        // this.bindRemoveButtons();
    }

    extractProductData(cartItem) {
        if (!cartItem) return { image: '', alt: '', title: 'Product' };

        // Try different selectors for product image
        let productImage = cartItem.querySelector('.cart-item__image img') ||
            cartItem.querySelector('.cart-drawer__item-image img') ||
            cartItem.querySelector('img');

        // Try different selectors for product title
        let productTitle = cartItem.querySelector('.cart-item__name') ||
            cartItem.querySelector('.cart-drawer__item-title') ||
            cartItem.querySelector('[data-product-title]') ||
            cartItem.querySelector('h3') ||
            cartItem.querySelector('h4');

        return {
            image: productImage ? productImage.src : '',
            alt: productImage ? productImage.alt : '',
            title: productTitle ? productTitle.textContent.trim() : 'Product'
        };
    }

    show(options) {
        const { title, subtitle, description, confirmText, cancelText, product, confirmCallback, noCallback } = options;

        // Update modal content
        this.overlay.querySelector('.removal-modal-title').textContent = title || '';
        this.overlay.querySelector('.removal-modal-description').textContent = description || '';
        this.overlay.querySelector('.removal-modal-button-confirm').textContent = confirmText || 'Confirm';
        this.overlay.querySelector('.removal-modal-button-cancel').textContent = cancelText || 'Cancel';
        this.overlay.querySelector('.removal-modal-subtitle').textContent = subtitle || '';

        // Update product info
        if (product) {
            console.log('product', product);
            const img = this.overlay.querySelector('.removal-modal-product-image');
            img.src = product.image;
            img.alt = product.alt;
        }

        // Show modal
        document.body.classList.add('removal-modal-open');
        this.overlay.classList.add('active');

        this.confirmCallback = confirmCallback;
        this.noCallback = noCallback;

        // Focus trap
        const confirmBtn = this.overlay.querySelector('.removal-modal-button-confirm');
        setTimeout(() => confirmBtn.focus(), 100);
    }

    hide() {
        document.body.classList.remove('removal-modal-open');
        this.overlay.classList.remove('active');

        // Reset loading states
        this.resetButtonStates();
    }

    isVisible() {
        return this.overlay.classList.contains('active');
    }

    async confirmRemoval() {
        const confirmBtn = this.overlay.querySelector('.removal-modal-button-confirm');
        const cancelBtn = this.overlay.querySelector('.removal-modal-button-cancel');

        // Set loading state
        confirmBtn.classList.add('loading');
        confirmBtn.disabled = true;
        cancelBtn.disabled = true;

        try {
            this.confirmCallback();
            this.hide();

        } catch (error) {
            console.error('Error removing item:', error);
            this.resetButtonStates();

            // Show error message (you can customize this)
            alert('There was an error removing the item. Please try again.');
        }
    }

    resetButtonStates() {
        const confirmBtn = this.overlay.querySelector('.removal-modal-button-confirm');
        const cancelBtn = this.overlay.querySelector('.removal-modal-button-cancel');

        confirmBtn.classList.remove('loading');
        confirmBtn.disabled = false;
        cancelBtn.disabled = false;
    }
}

// Initialize the modal when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    try {
        window.cartRemovalModal = new CartRemovalModal();
    } catch (error) {
        console.error('Failed to initialize Cart Removal Modal:', error);
    }
});